import { render } from "./InputList.vue?vue&type=template&id=65ea208e"
import script from "./InputList.vue?vue&type=script&lang=js"
export * from "./InputList.vue?vue&type=script&lang=js"
script.render = render

export default script